import { useCallback, useEffect, useState } from 'react';

const useClickAway = (ref) => {
  const [isVisible, setIsVisible] = useState(false);

  const onMouseDown = useCallback(
    (event) => {
      if (ref?.current && !ref.current.contains(event.target)) {
        setIsVisible(false);
      }
    },
    [ref],
  );

  useEffect(() => {
    document.addEventListener('mousedown', onMouseDown);

    return () => {
      document.removeEventListener('mousedown', onMouseDown);
    };
  }, [onMouseDown]);

  return [isVisible, setIsVisible];
};

export default useClickAway;
